export default __webpack_public_path__ + "static/media/icono.7be773e3.png";